import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { ChartDataItem } from "../../utils/chart-values";
import { roundTo1DP } from "./utils";

interface VasTableProps {
	chartData: ChartDataItem[];
}

export function VasTable({ chartData }: VasTableProps) {
	return (
		<Table>
			<TableHeader>
				<TableRow>
					<TableHead>Time Point</TableHead>
					<TableHead>VAS Score</TableHead>
					<TableHead>Entries</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{chartData.map((point) => (
					<TableRow key={point.schedule_index}>
						<TableCell>{point.timing}</TableCell>
						<TableCell>
							{point.entries_count > 0 ? roundTo1DP(point.value || 0) : "-"}
						</TableCell>
						<TableCell>{point.entries_count}</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
}
